'use strict';

angular.module('pulse')
    .filter('trustedHTML', ['$sce', function($sce) {
      return function(text) {
          return $sce.trustAsHtml(text);
      };
}]);
